<template>
  <el-menu-item
    :index="String('menu_' + item.arme_id + $randomNumber())"
    :key="'menu_' + item.arme_id + $randomNumber()"
  >
    <el-checkbox
      v-if="isSaveMenu"
      v-model="item.selected"
      @change="handleItemChange"
    ></el-checkbox>
    <small>
      {{ item.arme_nombre }}
    </small>
  </el-menu-item>
</template>

<script>
  export default {
    name: 'RecursiveMenuItem',
    props: {
      item: {
        type: Object,
        required: true
      },
      isSaveMenu: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      handleItemChange() {
        this.$emit('item-selected')
      }
    }
  }
</script>
